import React, { useContext, useState } from 'react';
import {
    CircularProgress,
    Grid,
    IconButton,
    InputLabel,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    withStyles
} from '@material-ui/core';
import { TCaredDashboardContext, TCaredDashboardProvider } from './tCaredDashboard-Provider';
import RemoveIcon from '@material-ui/icons/Remove';
import LockIcon from '@material-ui/icons/Lock';
import TodayIcon from '@material-ui/icons/Today';
import Tooltip from '@material-ui/core/Tooltip';
import { NavigateBefore, NavigateNext } from '@material-ui/icons';
import DialogComp from '../../../../Core/Controls/Dialog/DialogComp';
import moment from 'moment';
import TCardDashboardModal from './T-cardModal';
import TCardsCloseDay from './TCardsCloseDay';
import AddUpdateHoliday from '../Calendar/AddUpdateHoliday';
import { AppStorage } from '../../../../Core/Service/storage-service';
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import ConfirmationModal from '../../../../Core/Controls/Dialog/ConfirmationModal';
import TcardMapList from './TcardTemplates/TcardMapList';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import formatters from '../../../../Core/Grid/inputFormatter';
import CachedIcon from '@material-ui/icons/Cached';
import WeekDaysHeader from './TcardTemplates/weekdaysHeader';
import { Tcard } from './TcardTemplates/mainTcard';
import { HeadingTableCell, StyledTableCell } from './TcardTemplates/tableStyle';
import HolidayRow from './TcardTemplates/tcardHoliday';
import WeekdaysList from './TcardTemplates/weekDaysList';
import { createLogger } from '@microsoft/signalr/dist/esm/Utils';
import NotesRow from './TcardTemplates/tcardNotes';
import { TextBox } from '../../../../Core/FormInput';
import TechnicianShift from './TcardTemplates/tcardTechShift';
import CreateCalendarModal from '../WorkshopShiftSchedule/CreateCalendarModal';
import AssignTechnicianModal from '../WorkshopShiftSchedule/AssignTechnicianModal';
import UnassignTechnicianModal from '../WorkshopShiftSchedule/UnassignTechnicianModal';
import AddHolidayModal from '../WorkshopShiftSchedule/AddHolidayModal';

import './TcardTemplates/tcardTemplate.scss';
import AppContext from '../../../../App/AppContext';

const useStyles = makeStyles({
    table: {
        width: '99.7%',
        borderCollapse: 'collapse'
    },

    badgecss: {
        '& .MuiBadge-anchorOriginTopRightRectangle': {
            padding: '0 !important'
        }
    },

    colHeight: {
        overflowY: 'auto',
        verticalAlign: 'baseline'
    },
    Tcard: {
        cursor: 'pointer',
        padding: 3,
        border: '1px solid rgba(0,0,0,0.1)',
        position: 'relative',
        '&:hover': {
            border: '1px solid rgba(0,0,0,0.9)'
        }
    },
    editButton: {
        position: 'absolute',
        top: 5,
        right: 5,
        opacity: 0,
        transition: 'opacity 0.3s ease-in-out',
        background: 'white'
    },
    draggingOver: {
        backgroundColor: 'rgba(0, 0, 0, 0.12) !important'
    },
    noRecordFound: {
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '11px',
        fontWeight: 500,
        color: '#94a3b8',
        background: '#fafafa',
        border: '1px dashed #e2e8f0',
        borderRadius: '4px',
        margin: '2px'
    }
});

const formatTechName = (techID, techName, techList = []) => {
    if (techID) {
        const matched = techList.find((t) => String(t.id).toLowerCase() === String(techID).toLowerCase());
        if (matched) return matched.name;
    }
    if (!techName) return '';
    const part = techName.split('@')[0];
    return part
        .split(/[._-]/)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
};

const CardDash = (props) => {
    const {
        fullScreen,
        loader,
        tCardList,
        legendItems,
        handleCustomerFilter,
        handleRegNoFilter,
        handleFullScreen,
        checkIsTcardReadonly,
        history,
        handleCurrentWeek,
        reset,
        handleChange,
        branchList,
        curretDate,
        handlePlusButtonClick,
        submitTcardLock,
        changeWeek,
        count,
        handleDragEnd,
        updatedStatus,
        toBeScheduledCards,
        portalSetting,
        expand,
        handleExpand,
        handleTcardOpen,
        handleCalendarButtonClick,
        handleMOT,
        openModal,
        closeDayModal,
        setCloseDayModal,
        selectedDate,
        handleCloseDayModal,
        temp,
        ShowAllTcards,
        userHolidayModal,
        setUserHolidayModal,
        handleUserHolidayModal,
        motClose,
        handleCloseMOT,
        motFields,
        submitMotClose,
        filters,
        dayFull,
        handletSetDayFull,
        handletOpenDayFull,
        handletCloseSetDayFull,
        workType,
        shortListByTrailter,
        setMotColor,
        calendarOpen,
        handleTchnicianShift,
        closeTchnicianShift,
        technicianList,
        assignParams,
        unassignOpen,
        unassignParams,
        closeUnassignTechnician,
        holidayOpen,
        holidayParams,
        closeHoliday
    } = useContext(TCaredDashboardContext);
    const { showToast, showModal, portalSettings } = useContext(AppContext);

    const classes = useStyles();

    const firstColumn = [];
    const secondColumn = [];
    const thirdColumn = [];

    updatedStatus.flat().forEach((item) => {
        const [col, row] = item.tCardStatusequence.split('-').map(Number);

        const objWithRow = { ...item, row };

        if (col === 1) {
            firstColumn.push(objWithRow);
        } else if (col === 2) {
            secondColumn.push(objWithRow);
        } else if (col === 3) {
            thirdColumn.push(objWithRow);
        }
    });

    // Sort by row sequence
    firstColumn.sort((a, b) => a.row - b.row);
    secondColumn.sort((a, b) => a.row - b.row);
    thirdColumn.sort((a, b) => a.row - b.row);

    return (
        <div
            className={` custom-scroll`}
            style={{
                position: !fullScreen ? 'static' : 'fixed',
                top: 0,
                left: 0,
                width: !fullScreen ? '100%' : '100vw',
                height: !fullScreen ? '100%' : '100vh',
                background: '#f8fafc',
                zIndex: 1000,
                overflowY: 'hidden'
            }}
        >
            <TableContainer style={{ height: fullScreen ? '100vh' : 'calc(100vh - 110px)' }}>
                {loader ? (
                    <div style={{ marginTop: 30, width: '100%', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <Table className={classes.table} aria-label="simple table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="center" colSpan={3 + tCardList.closeDays?.length}>
                                    <Grid container spacing={1} justifyContent="space-between" alignItems="center">
                                        <Grid item>
                                            <Grid container spacing={1} alignItems="center">
                                                {legendItems.map((item, index) => (
                                                    <Grid item key={index}>
                                                        <div
                                                            className="tcard-legend-badge"
                                                            style={{
                                                                background: item.background,
                                                                color: item.color
                                                            }}
                                                        >
                                                            {item.label}
                                                        </div>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid container spacing={1} justifyContent="flex-end" alignItems="center">
                                                <Grid item>
                                                    <input
                                                        className="tcard-search-input"
                                                        onChange={handleCustomerFilter}
                                                        placeholder="🔍 Search customer..."
                                                        value={filters.cust}
                                                        name="cust"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <input
                                                        className="tcard-search-input"
                                                        onChange={handleRegNoFilter}
                                                        placeholder="🔍 Search Reg No..."
                                                        value={filters.regNo}
                                                        name="regNo"
                                                    />
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title={!fullScreen ? 'Full Screen' : 'Normal View'}>
                                                        <span className="tcard-icon-btn" onClick={handleFullScreen}>
                                                            {!fullScreen ? (
                                                                <FullscreenIcon style={{ fontSize: 20 }} />
                                                            ) : (
                                                                <FullscreenExitIcon style={{ fontSize: 20 }} />
                                                            )}
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                {!checkIsTcardReadonly && (
                                                    <Grid item>
                                                        <div
                                                            className="tcard-action-btn-primary"
                                                            onClick={() => history.push('/CheckInDashboard?branchID=' + tCardList.branchID)}
                                                        >
                                                            + Create T-Card
                                                        </div>
                                                    </Grid>
                                                )}

                                                <Grid item>
                                                    <div className="tcard-action-btn-success" onClick={handleCurrentWeek}>
                                                        Current Week
                                                    </div>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title="Reset Dates">
                                                        <span className="tcard-icon-btn" onClick={reset}>
                                                            <RotateLeftIcon style={{ fontSize: 20 }} />
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                <Grid item>
                                                    <select className="tcard-branch-select" onChange={handleChange} value={tCardList.branchID}>
                                                        {branchList.map((btn, i) => {
                                                            return (
                                                                <option key={i} value={btn.id}>
                                                                    {btn.name}
                                                                </option>
                                                            );
                                                        })}
                                                    </select>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <TableBody>
                                <TableRow>
                                    <HeadingTableCell align="center" rowSpan={2} style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}>
                                        <TcardMapList
                                            List={firstColumn}
                                            tCardList={tCardList}
                                            toBeScheduledCards={toBeScheduledCards}
                                            classes={classes}
                                            portalSetting={portalSetting}
                                            expand={expand}
                                            handleExpand={handleExpand}
                                            handleTcardOpen={handleTcardOpen}
                                            legendItems={legendItems}
                                            Tcard={Tcard}
                                            checkIsTcardReadonly={checkIsTcardReadonly}
                                        />
                                    </HeadingTableCell>
                                    <HeadingTableCell align="center" rowSpan={2} style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}>
                                        <TcardMapList
                                            List={secondColumn}
                                            tCardList={tCardList}
                                            toBeScheduledCards={toBeScheduledCards}
                                            classes={classes}
                                            portalSetting={portalSetting}
                                            expand={expand}
                                            handleExpand={handleExpand}
                                            handleTcardOpen={handleTcardOpen}
                                            legendItems={legendItems}
                                            Tcard={Tcard}
                                            checkIsTcardReadonly={checkIsTcardReadonly}
                                        />
                                    </HeadingTableCell>
                                    <HeadingTableCell align="center" rowSpan={2} style={{ minWidth: '200px', width: `${tCardList.calculateWidth}%` }}>
                                        <TcardMapList
                                            List={thirdColumn}
                                            tCardList={tCardList}
                                            toBeScheduledCards={toBeScheduledCards}
                                            classes={classes}
                                            portalSetting={portalSetting}
                                            expand={expand}
                                            handleExpand={handleExpand}
                                            handleTcardOpen={handleTcardOpen}
                                            legendItems={legendItems}
                                            Tcard={Tcard}
                                            checkIsTcardReadonly={checkIsTcardReadonly}
                                        />
                                    </HeadingTableCell>
                                    <StyledTableCell
                                        align="center"
                                        colSpan={tCardList.closeDays.length}
                                        rowSpan={updatedStatus.length + 3}
                                        style={{ padding: 0, width: tCardList.calculateWidth + tCardList.calculateWidth - 100 }}
                                        // width={`${tCardList.calculateWidth + tCardList.calculateWidth - 100}}`}
                                    >
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    {' '}
                                                    {tCardList.closeDays.map(({ dt, date, dayfull, tCardCalendarID }, index) => {
                                                        let hours = tCardList.allocatedHours.find(
                                                            (k) => moment(k.tCardsBookingDate).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD')
                                                        );

                                                        let closeDayStatus = tCardList.bookingConfirmed.filter(
                                                            (rw) => moment(rw.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD')
                                                        );

                                                        let bkList = closeDayStatus.filter((j) => j.status === 'BOOKING CONFIRMED');

                                                        let iscloseDay = bkList.length === 0;

                                                        let isToday = moment(dt).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD');

                                                        return (
                                                            <WeekDaysHeader
                                                                index={index}
                                                                tCardList={tCardList}
                                                                isToday={isToday}
                                                                dt={dt}
                                                                curretDate={curretDate}
                                                                iscloseDay={iscloseDay}
                                                                handlePlusButtonClick={handlePlusButtonClick}
                                                                tCardCalendarID={tCardCalendarID}
                                                                dayfull={dayfull}
                                                                hours={hours}
                                                                handletSetDayFull={handletSetDayFull}
                                                                changeWeek={changeWeek}
                                                                count={count}
                                                            />
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* Tech */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt }, index) => (
                                                        <TechnicianShift
                                                            tCardList={tCardList}
                                                            handleCalendarButtonClick={handleTchnicianShift}
                                                            dt={dt}
                                                            isDay={true}
                                                        />
                                                    ))}
                                                </TableRow>
                                                {/* Holiday */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt }, index) => (
                                                        <HolidayRow tCardList={tCardList} handleCalendarButtonClick={handleCalendarButtonClick} dt={dt} />
                                                    ))}
                                                </TableRow>
                                                {/* <TableRow>
                                                    {tCardList.closeDays.map(({ dt }, index) => (
                                                        <TechnicianShift tCardList={tCardList} handleCalendarButtonClick={handleCalendarButtonClick} dt={dt} />
                                                    ))}
                                                </TableRow> */}
                                                {/* Notes  */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, calNotes, tCardCalendarID }, index) => (
                                                        <NotesRow
                                                            tCardList={tCardList}
                                                            calNotes={calNotes}
                                                            handleCalendarButtonClick={handleCalendarButtonClick}
                                                            dt={dt}
                                                            tCardCalendarID={tCardCalendarID}
                                                        />
                                                    ))}
                                                </TableRow>
                                                {/* Day */}

                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const dayCards = tCardList.bookingConfirmed.filter(
                                                            (m) =>
                                                                moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') &&
                                                                !m.cd &&
                                                                !m.ns &&
                                                                m.status === 'BOOKING CONFIRMED'
                                                        );

                                                        return (
                                                            <WeekdaysList
                                                                label={'Day Shift'}
                                                                index={index}
                                                                isShowCount="true"
                                                                countList={tCardList.allocatedHours}
                                                                dt={dt}
                                                                mainCardList={dayCards}
                                                                isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                mainHead={true}
                                                                droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-ds`}
                                                                countKey={'dayAllocatedHours'}
                                                            />
                                                        );
                                                    })}
                                                </TableRow>

                                                {/* Collection and Delivery */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const cdCards = tCardList.bookingConfirmed.filter(
                                                            (m) =>
                                                                moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') &&
                                                                m.cd &&
                                                                !m.ns &&
                                                                m.status === 'BOOKING CONFIRMED'
                                                        );
                                                        return (
                                                            <>
                                                                <WeekdaysList
                                                                    label={'Collection and Delivery'}
                                                                    index={index}
                                                                    dt={dt}
                                                                    mainCardList={cdCards}
                                                                    isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                    droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-cd`}
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* MOT */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, motclosed, tCardCalendarID }, index) => {
                                                        const motCards = tCardList.bookingConfirmed.filter(
                                                            (m) =>
                                                                moment(m.motdate).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') &&
                                                                m.mot &&
                                                                m.status !== 'COLLECTED'
                                                        );

                                                        return (
                                                            <StyledTableCell align="center" key={index} className="card-body-container">
                                                                <div style={{ background: motclosed ? '#e2e8f0' : '', height: '100%' }}>
                                                                    <div
                                                                        className={motclosed ? 'card-body-container-main-header' : 'card-body-container-header'}
                                                                    >
                                                                        <Typography
                                                                            className="card-body-container-header-label"
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleMOT(dt, motclosed, tCardCalendarID)}
                                                                        >
                                                                            {portalSettings?.portalSettingsMOTText || 'MOT'}
                                                                        </Typography>
                                                                    </div>
                                                                    <div className={`${classes.colHeight} custom-scroll`}>
                                                                        {motCards.length === 0 ? (
                                                                            <div className="card-body-container-main-wrapper-no-record">
                                                                                <span
                                                                                    style={{
                                                                                        color: motclosed ? '#dc2626' : '',
                                                                                        fontWeight: motclosed ? '600' : 'normal'
                                                                                    }}
                                                                                >
                                                                                    {motclosed ? 'MOT is Closed' : 'No Record Found'}
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            motCards.map((k) => (
                                                                                <div key={k.tCardsID}>
                                                                                    <Tcard
                                                                                        legendItems={legendItems}
                                                                                        days={k.days}
                                                                                        handleTcardOpen={handleTcardOpen}
                                                                                        date={k.bd}
                                                                                        customer={k.cust}
                                                                                        isLoanVehicle={k.loanVehicle}
                                                                                        registration={k.reg}
                                                                                        color={setMotColor(k.motWorkTypeID, false)}
                                                                                        textColor={setMotColor(k.motWorkTypeID, true)}
                                                                                        tCardsID={k.tCardsID}
                                                                                        wn={k.wn}
                                                                                        vsc={k.vsc}
                                                                                        breakdown={k.breakdown}
                                                                                        breakdownStatus={k.breakdownStatus}
                                                                                        breakdownTime={k.breakdownTime}
                                                                                        pt={k.pt}
                                                                                        workDetails={k.workDetails}
                                                                                        technicians={k.technicians}
                                                                                        status={{
                                                                                            recall: k.recall,
                                                                                            tacho: k.tacho,
                                                                                            motdate: k.motdate,
                                                                                            motloc: k.motloc,
                                                                                            mot: k.mot,
                                                                                            repair: k.repair,
                                                                                            inspection: k.inspection,
                                                                                            cd: k.cd,
                                                                                            waiting: k.waiting,
                                                                                            service: k.service,
                                                                                            ns: k.ns
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            ))
                                                                        )}
                                                                    </div>
                                                                </div>{' '}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* Night Shift */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const nightShiftCards = tCardList.bookingConfirmed.filter(
                                                            (m) => moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') && m.ns && !m.cd
                                                        );

                                                        return (
                                                            <>
                                                                <WeekdaysList
                                                                    label={'Night Shift'}
                                                                    index={index}
                                                                    isShowCount="true"
                                                                    countList={tCardList.allocatedHours}
                                                                    countKey={'nightAllocatedHours'}
                                                                    dt={dt}
                                                                    mainCardList={nightShiftCards}
                                                                    isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                    mainHead={true}
                                                                    droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-ns`}
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </TableRow>
                                                {/* Collection and Delivery Night Shift */}
                                                <TableRow>
                                                    {tCardList.closeDays.map(({ dt, date, dayfull }, index) => {
                                                        const collectionDeliveryCards = tCardList.bookingConfirmed.filter(
                                                            (m) => moment(m.bd).format('YYYY-MM-DD') === moment(dt).format('YYYY-MM-DD') && m.cd && m.ns
                                                        );

                                                        return (
                                                            <>
                                                                <WeekdaysList
                                                                    label={'Collection and Delivery'}
                                                                    index={index}
                                                                    dt={dt}
                                                                    mainCardList={collectionDeliveryCards}
                                                                    isDragReadonly={checkIsTcardReadonly || dayfull}
                                                                    droppable_Id={`${moment(dt).format('YYYY-MM-DD')}-cd-ns`}
                                                                    ShowSat={true}
                                                                />
                                                            </>
                                                        );
                                                    })}
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </StyledTableCell>
                                </TableRow>
                                {/* <TableRow></TableRow> */}
                            </TableBody>
                        </DragDropContext>
                    </Table>
                )}
            </TableContainer>

            {/* ///Modals */}

            {dayFull.show ? (
                <DialogComp title="Warning" onClose={handletCloseSetDayFull} maxWidth="sm">
                    <ConfirmationModal
                        message={
                            dayFull.mode == 'set'
                                ? `Do you want to set ${formatters.MonthShortFormatter(dayFull.date)} as full? No further bookings will be allowed on the day`
                                : `Are you sure to open ${formatters.MonthShortFormatter(dayFull.date)} for bookings?`
                        }
                        handleSubmit={submitTcardLock}
                        handleCancel={handletCloseSetDayFull}
                    />
                </DialogComp>
            ) : null}

            {openModal ? <TCardDashboardModal id={tCardList.tCardID} onClose={handleTcardOpen} tCardSelectedColor={tCardList?.tCardSelectedColor} /> : null}
            {closeDayModal ? (
                <DialogComp title="Close Day" onClose={() => setCloseDayModal(false)} maxWidth="xs" fullWidth>
                    <TCardsCloseDay calID={selectedDate} onClose={handleCloseDayModal} />
                </DialogComp>
            ) : null}
            {temp.open ? (
                <DialogComp title={temp.name} onClose={() => ShowAllTcards(false, '', [])} maxWidth="xs" fullWidth>
                    <div onClick={() => ShowAllTcards(false, '', [])} style={{ height: '500px', overflowY: 'auto' }}>
                        {temp.list?.map((k) => {
                            return (
                                <Tcard
                                    legendItems={legendItems}
                                    handleTcardOpen={handleTcardOpen}
                                    days={k.days}
                                    date={k.bd}
                                    customer={k.cust}
                                    isLoanVehicle={k.loanVehicle}
                                    registration={k.reg}
                                    color={setMotColor(k.motWorkTypeID, false)}
                                    textColor={setMotColor(k.motWorkTypeID, true)}
                                    tCardsID={k.tCardsID}
                                    wn={k.wn}
                                    vsc={k.vsc}
                                    breakdown={k.breakdown}
                                    breakdownStatus={k.breakdownStatus}
                                    breakdownTime={k.breakdownTime}
                                    pt={k.pt}
                                    workDetails={k.workDetails}
                                    technicians={k.technicians}
                                    status={{
                                        recall: k.recall,
                                        tacho: k.tacho,
                                        motdate: k.motdate,
                                        motloc: k.motloc,
                                        mot: k.mot,
                                        repair: k.repair,
                                        inspection: k.inspection,
                                        cd: k.cd,
                                        waiting: k.waiting,
                                        service: k.service,
                                        ns: k.ns
                                    }}
                                />
                            );
                        })}
                    </div>
                </DialogComp>
            ) : null}
            {userHolidayModal ? (
                <DialogComp title="Add User Holiday" onClose={() => setUserHolidayModal(false)} maxWidth="md" fullWidth>
                    <AddUpdateHoliday selectedDate={selectedDate} onClose={handleUserHolidayModal} branchID={tCardList.branchID} />
                </DialogComp>
            ) : null}

            {motClose ? (
                <DialogComp title="Warning" onClose={handleCloseMOT} maxWidth="sm">
                    <ConfirmationModal message={motFields.motMessage} handleSubmit={submitMotClose} handleCancel={handleCloseMOT} />
                </DialogComp>
            ) : null}

            {calendarOpen && (
                <DialogComp title="Assign Technician" onClose={closeTchnicianShift} maxWidth="xs" fullWidth>
                    <AssignTechnicianModal
                        technicianList={technicianList || []}
                        shiftID={assignParams.shiftID}
                        shiftName={assignParams.shiftName}
                        branchName={tCardList.branch}
                        branchID={tCardList.branchID}
                        defaultStartDate={assignParams.startDate}
                        defaultEndDate={assignParams.endDate}
                        onClose={closeTchnicianShift}
                    />
                </DialogComp>
            )}

            {unassignOpen && (
                <DialogComp title="Unassign Technician" onClose={closeUnassignTechnician} maxWidth="xs" fullWidth>
                    <UnassignTechnicianModal
                        shiftID={unassignParams.shiftID}
                        shiftName={unassignParams.shiftName}
                        branchName={tCardList.branch}
                        branchID={tCardList.branchID}
                        defaultStartDate={unassignParams.startDate}
                        defaultEndDate={unassignParams.endDate}
                        existingAssignment={unassignParams.existingAssignment}
                        technicianName={unassignParams.technicianName}
                        onClose={closeUnassignTechnician}
                    />
                </DialogComp>
            )}

            {holidayOpen && holidayParams && (
                <DialogComp title="Add Holiday" onClose={closeHoliday} maxWidth="sm" fullWidth>
                    <AddHolidayModal
                        shiftID={holidayParams.shiftID}
                        shiftName={holidayParams.shiftName}
                        branchName={tCardList.branch}
                        branchID={tCardList.branchID}
                        defaultStartDate={holidayParams.startDate}
                        defaultEndDate={holidayParams.endDate}
                        existingAssignment={holidayParams.assignment}
                        technicianName={formatTechName(
                            holidayParams.assignment?.technicianUserID,
                            holidayParams.assignment?.technicianUserName,
                            technicianList
                        )}
                        onClose={closeHoliday}
                    />
                </DialogComp>
            )}
            {/* {true ? (
                <DialogComp title="Notes">
                    <InputLabel error>Notes </InputLabel>
                    <TextBox multiline rows={4} />
                </DialogComp>
            ) : null} */}
        </div>
    );
};

const TcardDashboard = (props) => {
    return (
        <TCaredDashboardProvider {...props}>
            <CardDash {...props} />
        </TCaredDashboardProvider>
    );
};
export default TcardDashboard;
